<template>
	<div class="page-wrapper" id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'PublicLayout'
}
</script>
